import React from 'react';
import PropTypes from 'prop-types';
import { Confirm } from 'react-confirm-bootstrap';
import { MenuItem } from 'react-bootstrap/lib';

function DeleteButton({ group, onDelete }) {
  return (
    <Confirm
      onConfirm={() => onDelete(group.id)}
      body={`Are you sure you want to delete ${group.name}?`}
      confirmText="Confirm Delete"
      title={`Deleting ${group.name}`}
    >
      <MenuItem>Delete</MenuItem>
    </Confirm>
  );
}

DeleteButton.propTypes = {
  group: PropTypes.object,
  onDelete: PropTypes.func,
};

export default DeleteButton;
